import React, { useState, useEffect } from "react";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { MySwal, AlertSwal, IconSwal } from "../CustomSwal";
import { FormattedMessage, useIntl } from "react-intl";
import { range } from "../../utils";

function AppointmentAllModal(props) {
  const [data, setData] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const sid = sessionStorage.getItem("sid");
  const authid = sessionStorage.getItem("authid");
  const config = props.config;
  const formType = props.allData.spacetype
    ? config.SPACETYPE[`st_${props.allData.spacetype}`][0]
    : null;
  const formUserNumber = props.params.bookuser;
  const userid = sessionStorage.getItem("userid");
  const intl = useIntl();

  const GetAllDataByDate = () => {
    let sdate = props.allData.sdate;
    let edate = props.allData.edate;
    const params = {
      sid: sid,
      authid: authid,
      spacetype: props.allData.spacetype,
      zoneid: props.selectedzone ? props.selectedzone.zoneid : null,
      sdate: sdate ? sdate.split("/").join("") : null,
      edate: edate ? edate.split("/").join("") : null,
      restype: "json",
    };
    props.setLoading(true);
    axios
      .get(config.API_URL + `/GetAllBookStatus.aspx`, {
        params: params,
      })
      .then((res) => {
        const data = res.data;
        if (data.rescode === 3 || data.rescode === 4) {
          props.setSession(false);
        } else {
          if (data.rescode === 1) {
            let stateData = [];

            for (let i = 0; i < data.deviceinfo.length; i++) {
              stateData[i] = {
                bookinfo: [],
                deviceinfo: data.deviceinfo[i].deviceinfo,
                deviceid: data.deviceinfo[i].deviceid,
                devicename: data.deviceinfo[i].devicename,
                usetype: data.deviceinfo[i].usetype,
                zoneid: props.selectedzone ? null : data.deviceinfo[i].zoneid,
              };

              const reformatted = [];
              for (let j = 0; j < data.bookvalue.length; j++) {
                reformatted.push({
                  booktitle: data.booktime[j] && data.booktime[j].split(":")[0],
                  bookdate: data.bookdate[j],
                  booktime: data.booktime[j] || null,
                  bookvalue: data.bookvalue[j],
                  canbook: data.deviceinfo[i].canbook[j],
                  mybookvalue: data.deviceinfo[i].mybookvalue[j],
                  closeday: data.deviceinfo[i].closeday[j],
                  reason: data.deviceinfo[i].reason[j],
                });
              }

              let temp = [];
              if (props.allData.spacetype === "26") {
                let morning = { key: "morning" };
                let noon = { key: "noon" };
                let night = { key: "night" };

                // 2-25-2022 新增，用在底下無法預約的時段要顯示的 booktime
                let periodTime = {};
                // 注意：由於陣列從小到大，以下早午晚的判斷邏輯很重要
                for (let i = 0; i < reformatted.length; i++) {
                  if (
                    parseInt(reformatted[i].bookvalue) === config.NOON_CONFIG[0]
                  ) {
                    periodTime.morning = `${
                      reformatted[0].booktime.split("~")[0]
                    }~${reformatted[i - 1].booktime.split("~")[1]}`;
                    periodTime.noon = `${
                      reformatted[i].booktime.split("~")[0]
                    }~`;
                  } else if (
                    parseInt(reformatted[i].bookvalue) === config.NOON_CONFIG[1]
                  ) {
                    periodTime.noon += reformatted[i].booktime.split("~")[1];
                    periodTime.night = `${
                      reformatted[i + 1].booktime.split("~")[0]
                    }~${
                      reformatted[reformatted.length - 1].booktime.split("~")[1]
                    }`;
                  }

                  // if (parseInt(data.bookvalue[j]) === config.NOON_CONFIG[0]) {
                  //   periodTime.morning = `${data.booktime[0].split('~')[0]}~${data.booktime[j - 1].split('~')[1]}`;
                  //   periodTime.noon = `${data.booktime[j].split('~')[0]}~`;
                  // } else if (parseInt(data.bookvalue[j]) === config.NOON_CONFIG[1]) {
                  //   periodTime.noon += data.booktime[j].split('~')[1];
                  //   periodTime.night = `${data.booktime[j + 1].split('~')[0]}~${data.booktime[data.bookvalue.length - 1].split('~')[1]}`
                  // }

                  const bv = parseInt(reformatted[i].bookvalue);
                  // 早上 bv < 下午開始
                  if (bv < config.NOON_CONFIG[0]) {
                    // 開始時間未定義 && 第一筆能預約的時間就是開始時間
                    if (!morning.start && reformatted[i].canbook === 1) {
                      morning.start = reformatted[i];
                      // 若不是第一筆就紀錄開始時間，表示不是完整的一個時段
                      if (i !== 0) morning.extraClass = "partial";
                    }
                    // 結束時間尚未定義 && 開始時間定義了 && 第一筆不能預約的時間的 前一筆 就是結束時間
                    if (
                      !morning.end &&
                      morning.start &&
                      reformatted[i].canbook === 0
                    ) {
                      morning.end = reformatted[i - 1];
                      morning.extraClass = "partial";
                    }
                    // 迴圈跑完了 && 尚未定義結束時間 = 會有兩種情況
                    if (bv === config.NOON_CONFIG[0] - 1 && !morning.end) {
                      // 1. 開始時間已經定義了 = 表示陣列沒有不能預約的時間，所以整個陣列的最後一筆就是結束時間
                      if (morning.start) morning.end = reformatted[i];
                      // 2. 開始時間也未定義 = 表示陣列全部時間都不能預約，看看是不是自己預約的，是的話給 mybook
                      if (reformatted[i].mybookvalue === 1)
                        morning.extraClass = "mybook";
                    }

                    // 晚上 bv > 下午結束
                  } else if (bv > config.NOON_CONFIG[1]) {
                    if (!night.start && reformatted[i].canbook === 1) {
                      night.start = reformatted[i];
                      if (
                        parseInt(reformatted[i - 1].bookvalue) !==
                        config.NOON_CONFIG[1]
                      )
                        night.extraClass = "partial";
                    }
                    if (
                      !night.end &&
                      night.start &&
                      reformatted[i].canbook === 0
                    ) {
                      night.end = reformatted[i - 1];
                      night.extraClass = "partial";
                    }
                    if (i === reformatted.length - 1 && !night.end) {
                      if (night.start) night.end = reformatted[i];
                      if (reformatted[i].mybookvalue === 1)
                        night.extraClass = "mybook";
                    }

                    // 剩下的皆為下午
                  } else {
                    if (!noon.start && reformatted[i].canbook === 1) {
                      noon.start = reformatted[i];
                      if (bv !== config.NOON_CONFIG[0])
                        noon.extraClass = "partial";
                    }
                    if (
                      !noon.end &&
                      noon.start &&
                      reformatted[i].canbook === 0
                    ) {
                      noon.end = reformatted[i - 1];
                      noon.extraClass = "partial";
                    }
                    if (bv === config.NOON_CONFIG[1] && !noon.end) {
                      if (noon.start) noon.end = reformatted[i];
                      if (reformatted[i].mybookvalue === 1)
                        noon.extraClass = "mybook";
                    }
                  }
                }

                const periodArr = [morning, noon, night];

                // 整理完畢後將 早 午 晚 寫進 state
                temp = periodArr.map((r) => {
                  // 開始結束都必須有資料，若無視為該時段無法預約
                  if (!r.start || !r.end) {
                    return {
                      ...reformatted[0],
                      bookvalue: "999," + Math.random(),
                      booktitle: intl.formatMessage({
                        id: `appointment.${r.key}`,
                      }),
                      booktime: periodTime[r.key],
                      canbook: 0,
                      extraClass: r.extraClass,
                    };
                  }
                  return {
                    ...r.start,
                    booktitle: intl.formatMessage({
                      id: `appointment.${r.key}`,
                    }),
                    booktime: `${r.start.booktime.split("~")[0]}~${
                      r.end.booktime.split("~")[1]
                    }`,
                    bookvalue: range(
                      parseInt(r.start.bookvalue),
                      parseInt(r.end.bookvalue),
                      1
                    ).join(","),
                    canbook: 1,
                    extraClass: r.extraClass,
                  };
                });
                // 如果來源陣列空的，直接將 temp 設為空陣列
                if (reformatted.length === 0) temp = [];
              } else {
                // 如果第一筆不是整點(bookvalue === 單數)，預先踢除獨立一筆，才進行陣列整理
                let firstRow = null;
                if (reformatted[0]?.bookvalue % 2 === 1) {
                  firstRow = reformatted.shift();
                  firstRow.extraClass =
                    reformatted[0].mybookvalue === 1 ? "mybook" : "";
                }
                // 開始整理陣列
                temp = reformatted.map((row, index) => {
                  // 兩筆合成一筆，所以 index % 2 === 1 的要拋棄
                  const nextRow = reformatted[index + 1] || reformatted[index];
                  if (index % 2 === 1) return null;
                  // 檢查兩筆的可預約是否一樣，不一樣的只顯示可預約的時段(半小時)
                  const canbookSame = row.canbook === nextRow.canbook;
                  if (canbookSame) {
                    // 一樣，合併兩筆
                    const mybook = row.mybookvalue === 1;
                    return {
                      ...row,
                      booktime: `${row.booktime.split("~")[0]}~${
                        nextRow.booktime.split("~")[1]
                      }`,
                      bookvalue: `${row.bookvalue},${nextRow.bookvalue}`,
                      canbook: row.canbook,
                      extraClass: mybook ? "mybook" : "",
                    };
                  } else {
                    // 不一樣，檢查是那一筆能預約，只顯示該筆
                    const canbookRow = row.canbook === 1 ? row : nextRow;
                    return {
                      ...canbookRow,
                      // 當時段不完整加上特殊 class，未來可加顏色
                      extraClass: "partial",
                    };
                  }
                });
                // 如果第一筆是有值的(表示第一筆不為整點，上方整理完畢後再將它加到陣列前面)
                if (firstRow) temp.unshift(firstRow);
              }
              stateData[i].bookinfo = temp.filter((r) => r !== null);
            }
            setData(stateData);
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const BookAdd = () => {
    // 檢查是否有選擇日期時間
    let bookvalues = document.querySelector('input[name="bookvalue"]:checked');
    const selectedItem = document.getElementById("deviceItem")
      ? document.getElementById("deviceItem").value
      : false;
    if (selectedItem === "") {
      AlertSwal.fire({
        title: intl.formatMessage({ id: "global.alert_title" }),
        text: intl.formatMessage({ id: "appointment.select_item" }),
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
      });
      return null;
    }
    if (bookvalues) {
      let swalMsg;
      let viewArr = [];
      let viewDates = [];
      let params = {};
      let selectedDeviceName = "";
      let bookvalue = "";
      // 取到選擇的 devicename
      data.find((elem) => {
        if (elem.deviceid === selectedArea) {
          selectedDeviceName = elem.devicename;
        }
        return null;
      });
      // userids 整理
      let useridparam = "";
      if (parseInt(formUserNumber) === 1) {
        useridparam = userid;
      } else if (parseInt(formUserNumber) > 1) {
        useridparam = userid + "," + props.allData.userids;
      }
      const checkboxes = document.getElementsByName("bookvalue");
      // 整理要送出的日期時間格式
      for (let i = 0, n = checkboxes.length; i < n; i++) {
        if (checkboxes[i].checked) {
          bookvalue += "," + checkboxes[i].value;
          viewArr.push(checkboxes[i].getAttribute("viewvalue"));
          viewDates.push(checkboxes[i].getAttribute("viewdate"));
        }
      }
      if (bookvalue) bookvalue = bookvalue.substring(1);
      // date time 參數 + swal 的內容 判別
      if (formType === "date") {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          bookdate: bookvalue,
          restype: "json",
        };
        swalMsg = (
          <div className="text-left">
            <span>{intl.formatMessage({ id: "global.reader_id" })} : </span>
            <span className="d-inline-block">{useridparam}</span>
            <br />
            <span>{intl.formatMessage({ id: "global.zonename" })} : </span>
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.zoneid.${props.selectedzone.zoneid}`,
                defaultMessage: props.selectedzone.zonename,
              })}
            </span>
            <br />
            <span>{intl.formatMessage({ id: "global.devicename" })} : </span>
            <span className="d-inline-block">{selectedDeviceName}</span>
            <br />
            <span>
              {intl.formatMessage({ id: "global.reservation_date" })} :{" "}
            </span>
            <span className="d-inline-block">
              {viewArr.length === 1
                ? viewArr[0]
                : `${viewArr[0]} ~ ${viewArr[viewArr.length - 1]}`}
            </span>
          </div>
        );
      } else if (formType === "time") {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          booktime: bookvalue,
          itemno: selectedItem ? selectedItem : "",
          restype: "json",
        };
        swalMsg = (
          <div className="text-left">
            <span>{intl.formatMessage({ id: "global.reader_id" })} : </span>
            <span className="d-inline-block">{useridparam}</span>
            <br />
            <span>{intl.formatMessage({ id: "global.zonename" })} : </span>
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.zoneid.${props.selectedzone.zoneid}`,
                defaultMessage: props.selectedzone.zonename,
              })}
            </span>
            <br />
            <span>{intl.formatMessage({ id: "global.devicename" })} : </span>
            <span className="d-inline-block">{selectedDeviceName}</span>
            <br />
            {selectedItem ? (
              <>
                <span>
                  {intl.formatMessage({ id: "appointment.select_item" })} :{" "}
                </span>
                <span className="d-inline-block">
                  {props.items[parseInt(selectedItem) - 1].itemname}
                </span>
                <br />
              </>
            ) : null}
            <span>
              {intl.formatMessage({ id: "global.reservation_date" })} :{" "}
            </span>
            <span className="d-inline-block">{props.allData.sdate}</span>
            <br />
            <span>
              {intl.formatMessage({ id: "global.reservation_time" })} :{" "}
            </span>
            <span className="d-inline-block">
              {viewArr.length === 1
                ? viewArr[0].replace("~", " ~ ")
                : `${viewArr[0].split("~")[0]} ~ ${
                    viewArr[viewArr.length - 1].split("~")[1]
                  }`}
            </span>
          </div>
        );
      } else if (formType === "night") {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: selectedArea,
          userid: useridparam,
          sdate: props.allData.sdate,
          booktime: bookvalue,
          restype: "json",
        };
        let datetimeText = "";
        if (viewArr.length === 1) {
          if (viewArr[0].split(" ").length > 1) {
            datetimeText =
              viewDates[0] + " " + viewArr[0].split(" ")[1].replace("~", " ~ ");
          } else {
            datetimeText = viewDates[0] + " " + viewArr[0].replace("~", " ~ ");
          }
        } else {
          let stext = "";
          let etext = "";
          if (viewArr[0].split(" ").length > 1) {
            stext = viewArr[0].split(" ")[1].split("~")[0];
          } else {
            stext = viewArr[0].split("~")[0];
          }
          if (viewArr[viewArr.length - 1].split(" ").length > 1) {
            etext = viewArr[viewArr.length - 1].split(" ")[1].split("~")[1];
          } else {
            etext = viewArr[viewArr.length - 1].split("~")[1];
          }
          if (viewDates[0] !== viewDates[viewArr.length - 1]) {
            datetimeText =
              viewDates[0] +
              " " +
              stext +
              " ~ " +
              viewDates[viewArr.length - 1] +
              " " +
              etext;
          } else {
            datetimeText = viewDates[0] + " " + stext + " ~ " + etext;
          }
        }
        swalMsg = (
          <div className="text-left">
            <span>{intl.formatMessage({ id: "global.reader_id" })} : </span>
            <span className="d-inline-block">{useridparam}</span>
            <br />
            <span>{intl.formatMessage({ id: "global.zonename" })} : </span>
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.zoneid.${props.selectedzone.zoneid}`,
                defaultMessage: props.selectedzone.zonename,
              })}
            </span>
            <br />
            <span>{intl.formatMessage({ id: "global.devicename" })} : </span>
            <span className="d-inline-block">{selectedDeviceName}</span>
            <br />
            <span>
              {intl.formatMessage({ id: "global.reservation_time" })} :{" "}
            </span>
            <span className="d-inline-block">{datetimeText}</span>
          </div>
        );
      }
      MySwal.fire({
        title: intl.formatMessage({ id: "appointment.reservation_detail" }),
        html: swalMsg,
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
        cancelButtonText: intl.formatMessage({ id: "global.cancel" }),
      }).then((result) => {
        if (result.value) {
          props.setLoading(true);
          axios
            .get(config.API_URL + `/BookAdd.aspx`, {
              params: params,
            })
            .then((res) => {
              const data = res.data[0];
              if (data.rescode === "3" || data.rescode === "4") {
                props.setSession(false);
              } else {
                if (data.rescode === "1") {
                  props.setshow(false);
                  if (config.SHOW_GOOGLE) {
                    IconSwal.fire({
                      title: intl.formatMessage({
                        id: "appointment.success_reservation",
                      }),
                      icon: "success",
                      html: (
                        <span>
                          {intl.formatMessage({
                            id: "appointment.add_to_google",
                          })}
                          ？
                        </span>
                      ),
                      showCancelButton: true,
                      confirmButtonText: intl.formatMessage({
                        id: "global.yes",
                      }),
                      cancelButtonText: intl.formatMessage({ id: "global.no" }),
                    }).then((result) => {
                      if (result.value) {
                        const googleForm =
                          document.getElementById("googleForm");
                        googleForm.querySelector(
                          "input[name=spacetype]"
                        ).value = props.allData.spacetype;
                        googleForm.querySelector("input[name=deviceid]").value =
                          selectedArea;
                        googleForm.querySelector("input[name=readerid]").value =
                          userid;
                        googleForm.querySelector(
                          "input[name=booksdate]"
                        ).value =
                          formType === "date"
                            ? viewDates[0]
                            : props.allData.sdate;
                        googleForm.querySelector(
                          "input[name=bookedate]"
                        ).value =
                          formType === "date"
                            ? viewDates[viewArr.length - 1]
                            : props.allData.sdate;
                        googleForm.querySelector(
                          "input[name=binbooktime]"
                        ).value = formType === "date" ? "" : bookvalue;
                        googleForm.submit();
                      }
                      props.setCurrent("info");
                      props.history.push("/redirect_to/info");
                    });
                  } else {
                    IconSwal.fire({
                      title: intl.formatMessage({
                        id: "appointment.success_reservation",
                      }),
                      icon: "success",
                      showCancelButton: false,
                      customClass: {
                        header:
                          "bg_swal swal-icon-header justify-content-around",
                        title: "modal-title",
                        icon: "swal-icon-class",
                        actions: "modal-footer d-flex justify-content-center",
                        confirmButton: "bg_brand btn btn-primary",
                      },
                    }).then((result) => {
                      props.setCurrent("info");
                      props.history.push("/redirect_to/info");
                    });
                  }
                } else {
                  let errMsg = data.resmsg.match(/\[(.*?)\]/);
                  AlertSwal.fire({
                    title: intl.formatMessage({ id: "global.alert_title" }),
                    text: errMsg
                      ? data.resmsg.split(errMsg[0])[0] +
                        intl.formatMessage({
                          id: `serverResponse.${errMsg[1]}`,
                        })
                      : intl.formatMessage({ id: "serverResponse.default" }),
                    confirmButtonText: intl.formatMessage({
                      id: "global.confirm",
                    }),
                  });
                }
              }
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              props.setLoading(false);
            });
        }
      });
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: "global.alert_title" }),
        text: intl.formatMessage({ id: "appointment.alert.select_period" }),
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
      });
    }
  };

  const handleChange = (elem) => {
    if (props.allData.enableToBook) {
      setSelectedArea(elem.currentTarget.value);
    }
  };

  const itemsSelect = (
    <Form.Control id="deviceItem" as="select" size="sm" defaultValue="">
      <option value="" disabled>
        {intl.formatMessage({ id: "appointment.select_item" })}
      </option>
      {props.items.map((row) => {
        return (
          <option key={row.itemno} value={row.itemno}>
            {row.itemname}
          </option>
        );
      })}
    </Form.Control>
  );

  useEffect(GetAllDataByDate, []);

  return (
    <Modal
      size="xl"
      show={props.show}
      onHide={() => {
        props.setAllShow(false);
      }}
      centered
      scrollable
      backdropClassName="double_modal_backdrop"
      dialogClassName="modal-95w"
      className="double_modal all_modal"
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>
          <span>
            <FormattedMessage
              defaultMessage={props.allData.zonename}
              id={
                props.selectedzone
                  ? `global.zoneid.${props.selectedzone.zoneid}`
                  : `global.spacetype.${props.allData.spacetype}`
              }
            />
            <FormattedMessage id="appointment.all_booking_list" />
          </span>
          <span>
            {props.allData.edate
              ? props.allData.sdate + " ~ " + props.allData.edate
              : props.allData.sdate}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Alert variant="danger" className="mb-2">
              {props.allData.enableToBook ? (
                <span className="d-block">
                  <FormattedMessage id="appointment.all_modal_reminder" />
                </span>
              ) : null}
              <span className="d-inline-block">
                <FormattedMessage id="appointment.max_value" />
                {props.params.oncecanbooktime === "1" ? (
                  <FormattedMessage
                    id={
                      "appointment.alert." +
                      (formType === "date"
                        ? "reach_max_date_value"
                        : "reach_max_time_value")
                    }
                    values={{ value: props.params.oncecanbooktime }}
                  />
                ) : (
                  <FormattedMessage
                    id={
                      "appointment.alert." +
                      (formType === "date"
                        ? "reach_max_date_values"
                        : "reach_max_time_values")
                    }
                    values={{ value: props.params.oncecanbooktime }}
                  />
                )}
              </span>
            </Alert>
          </Col>
          {data === null ? (
            <Col sm={12}>Loading</Col>
          ) : data.length === 0 ? (
            <Col sm={12}>
              <FormattedMessage id="appointment.no_data" />
            </Col>
          ) : (
            data.map((row, index) => {
              const isMac = config.IS_MAC_DEVICEID.find(
                (elem) => elem === row.deviceid
              )
                ? true
                : false;
              const isChecked = selectedArea === row.deviceid;
              return (
                <Col key={index} sm={12}>
                  <div className="d-flex align-items-center mb-1">
                    {row.deviceinfo !== "" && row.deviceinfo !== null ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{row.deviceinfo}</Tooltip>}
                      >
                        <i className="deviceinfo-icon information-icon"></i>
                      </OverlayTrigger>
                    ) : null}
                    {row.usetype === 4 ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <FormattedMessage id="appointment.accessibility_space" />
                          </Tooltip>
                        }
                      >
                        <i className="deviceinfo-icon accessibility-icon"></i>
                      </OverlayTrigger>
                    ) : null}
                    {isMac ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            <FormattedMessage id="appointment.mac_device" />
                          </Tooltip>
                        }
                      >
                        <div style={{ margin: "-5px 0 0 -6px" }}>
                          <i className="deviceinfo-icon mac-icon"></i>
                        </div>
                      </OverlayTrigger>
                    ) : null}
                    <Form.Group className="device_radio">
                      <Form.Check
                        inline
                        id={`deviceRadio${index}`}
                        name="device"
                        value={row.deviceid}
                        type="radio"
                        checked={isChecked}
                        disabled={row.bookinfo.length === 0}
                        label={
                          row.zoneid
                            ? `${intl.formatMessage({
                                id: `global.zoneid.${row.zoneid}`,
                              })}【${row.devicename}】 :`
                            : `【${row.devicename}】:`
                        }
                        enabletobook={props.allData.enableToBook.toString()}
                        onChange={handleChange}
                      />
                      {isChecked &&
                      config.IS_ITEM_DEVICEID.find(
                        (elem) => elem === row.deviceid
                      )
                        ? itemsSelect
                        : null}
                    </Form.Group>
                  </div>
                  <AllCheckArea
                    data={row.bookinfo}
                    params={props.params}
                    enable={props.allData.enableToBook && isChecked}
                    formType={formType}
                    intl={intl}
                  />
                </Col>
              );
            })
          )}
        </Row>
      </Modal.Body>
      {props.allData.enableToBook ? (
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="light"
            onClick={() => {
              props.setAllShow(false);
            }}
          >
            <FormattedMessage id="global.back" />
          </Button>
          <Button
            className="bg_brand"
            variant="primary"
            onClick={() => {
              BookAdd();
            }}
          >
            <FormattedMessage id="appointment.confirm_reservation_detail" />
          </Button>
        </Modal.Footer>
      ) : null}
    </Modal>
  );
}

function AllCheckArea(props) {
  const [checked, setChecked] = useState([]);
  const intl = props.intl;

  const handleCheck = (i) => {
    // 若 i 已勾選
    if (checked.find((elem) => elem === i)) {
      // 取消勾選 i 及 i 以後的日期時間
      setChecked(
        checked.filter((elem) => elem !== i && parseInt(elem) < parseInt(i))
      );
    } else {
      // 若 i 未勾選
      let newState = [];
      // 若目前有任何勾選 && 若 i 大於目前已勾選的最小值
      if (checked.length !== 0 && parseInt(i) > parseInt(checked[0])) {
        let cantBookInMiddle = null;
        // 勾選所有 i 與 最小值之間的選項
        props.data.map((row, index) => {
          const rowVal = parseInt(
            row.bookvalue.includes(",")
              ? row.bookvalue.split(",")[0]
              : row.bookvalue
          );
          const iVal = parseInt(i.includes(",") ? i.split(",")[0] : i);
          const checkedVal = parseInt(
            checked[0].includes(",") ? checked[0].split(",")[0] : checked[0]
          );
          const lastVal = parseInt(
            newState[newState.length - 1]?.includes(",")
              ? newState[newState.length - 1].split(",").pop()
              : newState[newState.length - 1]
          );
          // 2022-01-27 新增 .split(',')[0] 陽明交大半小時改為 1 小時，對比時只抓前一個時間
          if (rowVal <= iVal && rowVal >= checkedVal) {
            // 中間有無法預約的時段 ，記錄該 index
            if (row.canbook === 0 && cantBookInMiddle === null) {
              cantBookInMiddle = newState.length;
            }
            // 選擇的時間不連續
            if (lastVal && rowVal !== lastVal + 1) {
              cantBookInMiddle = newState.length;
            }
            newState.push(row.bookvalue);
          }
          return null;
        });
        // 刪掉 index 後的 elem
        if (cantBookInMiddle) {
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: intl.formatMessage({
              id: "appointment.alert.middle_duplicate",
            }),
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
          newState = newState.splice(0, cantBookInMiddle);
        }
        // 刪掉超過最大天數的 elem
        if (props.formType === "date") {
          if (newState.length > parseInt(props.params.oncecanbooktime)) {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              html:
                `<span>` +
                intl.formatMessage({ id: "appointment.alert.reach_max_date" }) +
                `<span class='d-inline-block'>` +
                intl.formatMessage(
                  { id: "appointment.alert.reach_max_date_value" },
                  {
                    value: props.params.oncecanbooktime,
                  }
                ) +
                `</span></span>`,
            });
            const delCount =
              newState.length - parseInt(props.params.oncecanbooktime);
            newState.splice(newState.length - delCount, newState.length);
          }
        } else {
          // 2022-01-27 把 newState.length/2 移除 陽明交大半小時改為 1 小時，無需再除 2
          // if ((newState.length / 2) > parseInt(props.params.oncecanbooktime)) {
          if (newState.length > parseInt(props.params.oncecanbooktime)) {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              html:
                `<span>` +
                intl.formatMessage({ id: "appointment.alert.reach_max_time" }) +
                `<span class='d-inline-block'>` +
                intl.formatMessage(
                  { id: "appointment.alert.reach_max_time_value" },
                  {
                    value: props.params.oncecanbooktime,
                  }
                ) +
                `</span></span>`,
            });
            // let delCount = ((newState.length / 2) - parseInt(props.params.oncecanbooktime)) * 2;
            let delCount =
              newState.length - parseInt(props.params.oncecanbooktime);
            newState.splice(newState.length - delCount, newState.length);
          }
        }
      } else {
        // 若未有任何勾選 || 若 i 小於最小值
        // 只改為勾選 i
        newState.push(i);
      }
      // setChecked(prevState => [...prevState, i]);
      setChecked(newState);
    }
  };

  useEffect(() => {
    if (props.enable === false) {
      setChecked([]);
    }
  }, [props.enable]);

  let prevDate = "";
  return (
    <Row className="deviceArea">
      {props.data === null ? (
        <Col sm={12}>Loading</Col>
      ) : props.data.length === 0 ? (
        <Col sm={12}>
          <FormattedMessage id="appointment.no_data" />
        </Col>
      ) : (
        props.data.map((row, index) => {
          let showDate = null;
          if (props.formType === "night" && prevDate !== row.bookdate) {
            showDate = row.bookdate;
            prevDate = row.bookdate;
          }
          const isChecked = checked.find((elem) => elem === row.bookvalue)
            ? true
            : false;
          return (
            <Col key={row.bookvalue} sm={6} md={4} lg={3} xl={2}>
              <Card
                border="dark"
                onClick={() => {
                  if (props.enable) {
                    handleCheck(row.bookvalue);
                  }
                }}
                style={props.enable ? null : { pointerEvents: "none" }}
                className={
                  row.canbook === 0
                    ? "disabled " + row.extraClass
                    : row.extraClass
                }
              >
                <Card.Body className="d-flex justify-content-around align-items-center">
                  <div className="text-center device_info">
                    <b className="d-block">{row.booktitle}</b>
                    <b>
                      {showDate}{" "}
                      {props.formType === "date" ? row.bookdate : row.booktime}
                    </b>
                  </div>
                  {props.enable ? (
                    <div>
                      <Form.Check
                        viewdate={row.bookdate}
                        viewvalue={
                          props.formType === "date"
                            ? row.bookdate
                            : row.booktime
                        }
                        name="bookvalue"
                        value={row.bookvalue}
                        aria-label={`bookvalue_${row.bookvalue}`}
                        checked={isChecked}
                        readOnly
                        disabled={row.canbook === 0}
                      />
                    </div>
                  ) : null}
                </Card.Body>
              </Card>
            </Col>
          );
        })
      )}
    </Row>
  );
}

export default AppointmentAllModal;
